import { render } from "./N3Badge.vue?vue&type=template&id=e13bf988"
import script from "./N3Badge.vue?vue&type=script&lang=js"
export * from "./N3Badge.vue?vue&type=script&lang=js"

import "./N3Badge.vue?vue&type=style&index=0&id=e13bf988&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__